import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Select } from '@ngxs/store';
import { DxDataGridComponent, DxDropDownBoxComponent } from 'devextreme-angular';
import { Observable, Subscription } from 'rxjs';
import { EmplacementStockDto } from 'src/api/models';
import { ArticleDto } from 'src/api/models/article-dto';
import { DevExtremeTranslationService } from 'src/core/services/devExtremeTranslation.service';
import { PanelLayoutService } from 'src/core/services/panel-layout.service';
import { ControlPanelStore } from 'src/states/control-panel.store';

@Component({
  selector: 'app-emplacement-select',
  templateUrl: './emplacement-select.component.html',
  styleUrls: ['./emplacement-select.component.css']
})
export class EmplacementSelectComponent implements OnInit {
  @Select(ControlPanelStore.emplacements$) emplacements$: Observable<EmplacementStockDto[]>;

  @ViewChild('dxDropDown') dropDown: DxDropDownBoxComponent;
  @ViewChild('dataGrid') dataGrid: DxDataGridComponent;

  @Input() disabled: boolean = false;
  @Input() readOnly: boolean = false;
  @Input() width: number;
  @Input() widthPopUp: number = 400;

  @Input() parcId: number;

  @Input() id: number;
  @Output() idChange = new EventEmitter<number>();

  @Input() cell: any;

  InitId = null;

  Emplacements: EmplacementStockDto[] = [];
  ColumnName = [];

  e: Subscription;

  constructor(private panelLayoutService: PanelLayoutService,
    private translate: TranslateService,
    private devExtremeTranslationService: DevExtremeTranslationService) {
      // Instanciate Globalize for DevExtreme components
      this.devExtremeTranslationService.loadLanguage(this.translate.getBrowserLang());
      this.translate.get(
        [
          'Nom',
          'Recyparc'
        ]
        ).subscribe(translations => {
          this.ColumnName.push(translations['Nom']);
          this.ColumnName.push(translations['Recyparc']);
        });
    }

  ngOnInit() {
    if(this.id != null) {
      this.InitId = JSON.parse(JSON.stringify(this.id));
    }
    this.e = this.emplacements$.subscribe(res => {
      if (res != null) {
        this.Emplacements = res;
        if(this.parcId) {
          this.Emplacements = this.Emplacements.filter(e => e.ParcId == this.parcId);
        }
      }
    });
  }

  ngOnDestroy() {
    this.e?.unsubscribe();
  }

  updateInfo(event) {
    this.id = event.currentSelectedRowKeys.length == 1 ? event.currentSelectedRowKeys[0].Id : this.id;
    if (!!this.cell && this.InitId != this.id) {
      this.cell.setValue(this.id);
    }
    this.idChange.emit(this.id);

    if(this.id != null) {
      this.dropDown.instance.close();
    }
  }

  onOpened() {
    if(this.id == null) {
      this.dataGrid.instance.clearSelection();
    }

    document.body.childNodes.forEach(element => {
      if(element.nodeType == 1) {
        if((element as HTMLElement).className.includes("dx-dropdowneditor-overlay")) {
          (element.childNodes[0] as HTMLElement).style.width = `${this.widthPopUp}px`;
        }
      }
    });
  }
}
